import React, { useEffect, useRef } from 'react';
import { Box, Button, Typography } from '@mui/material';

import useAppCtx from '../../hooks/useAppCtx';
import Banner from './components/Banner';
import Redemption from './components/Redemption';
import PendingTx from './components/PendingTx';
import Title from '../common/Title';
import Footer from '../common/Footer';
import compass from '../../assets/images/compass12.png';
import Header from '../Header/Header';

const Home = () => {
  const { txInProgress } = useAppCtx();
  const collectionRef = useRef(null);
  const redemptionRef = useRef();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const scrollToRef = (ref) => {
    if (ref.current) {
      window.scrollTo({
        left: 0,
        top: ref.current.offsetTop - 170,
        behavior: 'smooth',
      });
    }
  };

  const clickedToTheSameLink = () => {
    console.log('clicked same');
    if (location.hash === '#/#collection') {
      if (collectionRef) {
        scrollToRef(collectionRef);
      }
    } else if (location.hash === '#/#redemption') {
      if (redemptionRef) {
        scrollToRef(redemptionRef);
      }
    } else if (location.hash === '/#') {
      window.scrollTo(0, 0);
    }
  };
  useEffect(() => {
    if (location.hash === '#/#collection') {
      if (collectionRef) {
        scrollToRef(collectionRef);
      }
    } else if (location.hash === '#/#redemption') {
      if (redemptionRef) {
        scrollToRef(redemptionRef);
      }
    } else if (location.hash === '/#') {
      window.scrollTo(0, 0);
    }
  }, [location.hash]);

  return (
    <>
      {!txInProgress && (
        <>
          <Header clickedToTheSameLink={clickedToTheSameLink} />

          <Banner />
          <Title text="The Collection of Twelve" ref={collectionRef} />
          <Box style={{ maxWidth: '900px', margin: 'auto', marginTop: '59px' }}>
            <img
              src={compass}
              style={{ width: '100%', marginTop: '0px', margin: '0 auto' }}
              alt="image"
            />
          </Box>
          <Title text="The Equinox Forge" ref={redemptionRef} />

          <Redemption />
          <Footer />
        </>
      )}

      {txInProgress && <PendingTx />}
    </>
  );
};

export default Home;
